document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.calculator-modal')

  if (modals) {
    let isMobile = window.innerWidth < 1024
    window.addEventListener('resize', () => {
      isMobile = window.innerWidth < 1024
    })

    modals.forEach(modal => {
      const button = modal.querySelector('.calculator-modal__info-button')
      const background = modal.querySelector('.calculator-modal__background')
      const buttonClose = modal.querySelector('.calculator-modal__close')
      button?.addEventListener('click', () => {
        if (isMobile) {
          modal.classList.add('calculator-modal--view')
          document.body.classList.add('body--no-scroll')
        }
      })

      const closeModal = () => {
        if (isMobile) {
          modal.classList.remove('calculator-modal--view')
          document.body.classList.remove('body--no-scroll')
        }
      }

      background?.addEventListener('click', closeModal)

      buttonClose?.addEventListener('click', closeModal)
    })
  }
})